<template>
  <v-container fluid class="pa-0">
    <BlogPostHero :post="post" />
    <v-container>
      <p class="caption mb-0">
        {{ post.formatted_first_date }} - {{ post.formatted_date }}
      </p>
      <v-row>
        <v-col cols="12" md="8">
          <BlogContent :blocks="post.body" />
        </v-col>
        <v-col cols="12" md="4">
          <AuthorCard
            v-if="recentPostsByAuthor.length > 0"
            :author="post.owner"
            :items="recentPostsByAuthor"
            type="posts"
          />
        </v-col>
      </v-row>
      <Comments type="blogpost" :model="post" />
      <PartnerAd />
    </v-container>
  </v-container>
</template>

<script>
import BlogPostHero from '@/components/blog/BlogPostHero'
import BlogContent from '@/components/blog/BlogContent'
import Comments from '@/components/Comments'
import AuthorCard from '@/components/AuthorCard'
import PartnerAd from '@/components/ads/PartnerAd'

export default {
  name: 'BlogDetailPage',
  components: {
    BlogContent,
    BlogPostHero,
    Comments,
    AuthorCard,
    PartnerAd,
  },
  async asyncData(context) {
    try {
      const url = `/api/v2/blogpage/${context.params.slug}/`
      const { data: post } = await context.$axios.get(url)
      let recentPostsByAuthor = []

      if (post.owner) {
        const recentUrl = `/api/v2/blogpage/?owner=${post.owner.id}&page_size=3`
        const {
          data: { results },
        } = await context.$axios.get(recentUrl)

        recentPostsByAuthor = results
      }

      return {
        post,
        recentPostsByAuthor,
      }
    } catch (err) {
      if (err.response.status === 404) {
        return context.error({ statusCode: 404, message: err.message })
      } else {
        context.error(err.message)
      }
    }
  },
  mounted() {
    // Send event to Facebook Pixel
    this.$fb.track('ViewContent', {
      resource: 'Blog',
      details: { id: this.post.id, name: this.post.title },
    })
  },
  head() {
    const { preview, title, slug, main_image: mainImage } = this.post

    const description = preview.slice(0, 150)
    const name = `Happyly: ${title}`
    const url = `https://happyly.com/blog/${slug}`
    const image = mainImage
      ? `${this.$config.staticUrl}${mainImage.optimized}`
      : `${this.$config.staticUrl}/media/happyly_Logo_dwt.f9715d34.png`

    return {
      title: name,
      meta: [
        { hid: 'description', name: 'description', content: description },
        { hid: 'image', name: 'image', content: image },
        { hid: 'twitter:title', name: 'twitter:title', content: name },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content: description,
        },
        { hid: 'twitter:image:src', name: 'twitter:image:src', content: image },
        { hid: 'og:title', property: 'og:title', content: name },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description,
        },
        { hid: 'og:image', property: 'og:image', content: image },
        { hid: 'og:image:alt', property: 'og:image:alt', content: name },
        { hid: 'og:url', property: 'og:url', content: url },
      ],
      link: [
        {
          rel: 'canonical',
          href: 'https://happyly.com' + this.$route.path,
        },
      ],
    }
  },
}
</script>
